import { OnboardingRoutes } from '@/features/onboarding';

export const onboardingRoutes = [
  {
    path: '/*',
    element: <OnboardingRoutes />,
  },
];
